import React from 'react';
import clsx from 'clsx';

import { Badge, Box, Col, PositionedOverlay, PositionedOverlayAnchor, PositionedOverlayBase } from 'reaxl';

function MyWalletGridTiles({ className = '', tileProps = {}, xs, sm, md, lg, ...rest }) {
    const {
        badge = '',
        category = '',
        headline = '',
        summary = '',
        onClick = () => {},
        onKeyDown = () => {},
        contentMinHeight = '',
        dataCmp = '',
    } = tileProps;

    const boxProps = {
        className: clsx('flex-1 margin-vertical-2', className),
        onKeyDown,
        ...rest,
    };

    if (onClick) {
        boxProps.onClick = onClick;
        boxProps.tabIndex = 0;
        boxProps.role = 'button';
    }

    const columnProps = {
        ...(xs && { xs }),
        ...(sm && { sm }),
        ...(md && { md }),
        ...(lg && { lg }),
    };

    const withPositionedOverlay = (children) => (
        <PositionedOverlay shrinkwrap={false}>
            <PositionedOverlayBase key="tradeInBadgeOverlayBase">
                {children}
                <PositionedOverlayAnchor
                    key="tradeInOverlayAnchor"
                    offsetRight={75}
                    offsetTop={75}
                    position="topRight"
                >
                    <Badge circle>1</Badge>
                </PositionedOverlayAnchor>
            </PositionedOverlayBase>
        </PositionedOverlay>
    );

    const renderContents = (
        <div
            className="display-flex flex-column justify-content-between "
            style={contentMinHeight ? { height: contentMinHeight } : undefined}
        >
            {category ?? category}
            {headline && <div>{headline}</div>}
            {summary ?? summary}
        </div>
    );

    return (
        <Col
            className="display-flex"
            data-cmp="wallet-grid-tile-container"
            {...columnProps}
        >
            <Box
                backgroundColor="neutral-primary"
                border
                data-cmp={dataCmp}
                padding="compact"
                {...boxProps}
            >
                {(category || headline || summary) && (badge ? withPositionedOverlay(renderContents) : renderContents)}
            </Box>
        </Col>
    );
}

export default MyWalletGridTiles;
